/**
 * The login screen's API seam.
 *
 * Every page in this app keeps its calls in `pages/<page>/api/`, and this file
 * stays for that reason — but it no longer makes a request of its own. The HTTP
 * lives in ONE module, `src/services/authProviders.js`, because the login screen
 * and the export screens now share the same envelope, the same message codes and
 * the same body-field spelling (`labelflow_password`, `actor_password`), and two
 * copies of that knowledge drift the first time one of them is corrected.
 *
 * What this file therefore is: the list of calls the LOGIN screen is allowed to
 * make, named for what the screen does with them. The connect/disconnect/recheck
 * calls in the same service are the export screen's, not this one's.
 *
 * The old `getLogin` is gone. It threw on anything but a 401, which collapsed
 * every distinguishable outcome of the cascade — "that address already has a
 * LabelFlow account, prove it and we will link them", "this is a platform
 * administrator account, it owns no site", "too many attempts" — into one catch
 * block that reported "Failed to log in. Please try again later." Nothing else
 * in `src/` imported it (checked), so it is removed rather than deprecated.
 */

export {
  MSG,
  // Sign in: one email, one password, against every provider that can answer
  // for them. There is no provider picker — see useLogin.js.
  login as postLogin,
  // The second half of MSG_LINK_REQUIRED.
  completeLinkLogin as postCompleteLink,
  // The second half of `data.mustSetPassword`.
  bootstrapHomePassword as postBootstrapPassword,
  // The provider catalogue. Unauthenticated, carries no credential, and is what
  // lets the form say which OTHER accounts work here without offering a choice.
  getProviders,
} from '../../../../services/authProviders';
